//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import PermissionsManagementTable from "@/pages/PermissionsManagement/components/PermissionsManagementTable.vue";
import PermissionsManagementForm from "@/pages/PermissionsManagement/components/PermissionsManagementForm.vue";

//Status corrente está a vir se o utilizador esta atualmente com sessão iniciada
const EMPTY_ROLE = {
  name: null,
  permissions: [],
};

export default {
  name: "PermissionsManagement",
  components: {
    PermissionsManagementTable,
    PermissionsManagementForm,
  },
  mounted: function () {
    BackendServices.getRolesList().then((response) => {
      this.recordsTotal = Number(response.headers["x-total-count"]);
      this.tableData = response.data;
      this.isLoading = false;
    });
    //getAvailablePermissionsList
  },
  data: () => ({
    data: null,
    recordsTotal: 0,
    isLoading: false,
    tableData: [],
    rightSideClicked: false,
    separator: "horizontal",
    pagination: {
      rowsPerPage: 30, // current rows per page being displayed
    },
    role: {},
    availablePermissions: [],
    drawerMode: "",
  }),
  methods: {
    createNewRole: function () {
      this.rightSideClicked = true;
      this.drawerMode = "create";
      this.data = EMPTY_ROLE;
    },
    renderRightSide: function (event) {
      this.drawerMode = "edit";
      this.rightSideClicked = true;
      this.data = event;
    },
    closeForm: function () {
      this.rightSideClicked = false;
      this.newPhantomClicked = false;
    },
    //Alterar
    updatePermission(event) {
      this.role = event;
    },
    //Alterar
    savePermission() {
      if (this.drawerMode == "create") {
        this.createRole();
        this.role.created_by = this.$store.getters.userId;
      } else if (this.drawerMode == "edit") {
        this.updateRole();
      }
    },
    createRole() {
      this.role.created_by = this.$store.getters.userId;
      BackendServices.managePermission(this.role).then(() =>
        window.location.reload()
      );
    },
    updateRole() {
      this.role.created_by = this.$store.getters.userId;
      BackendServices.managePermission(this.role).then(() =>
        window.location.reload()
      );
    },
  },
};
